"use client";

import * as React from "react";
import { SideOverlayDrawer } from "./side-overlay-drawer";
import { Input } from "./input";
import { Textarea } from "./textarea";

export interface SeoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  metaTitle: string;
  metaDescription: string;
  onMetaTitleChange?: (value: string) => void;
  onMetaDescriptionChange?: (value: string) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function SeoDrawer({
  isOpen,
  onClose,
  metaTitle,
  metaDescription,
  onMetaTitleChange,
  onMetaDescriptionChange,
  onSave,
  isSaving,
}: SeoDrawerProps) {
  return (
    <SideOverlayDrawer isOpen={isOpen} onClose={onClose} title="SEO" onBack={onClose}>
      <div className="space-y-6 text-[#344054]">
        <div className="space-y-1">
          <p className="font-plus-jakarta-sans text-base font-semibold">Custom metadata</p>
          <p className="text-sm text-[#475467]">
            Changes to metadata may take some time to appear on other platforms.
          </p>
        </div>

        <div className="space-y-5">
          <div className="space-y-2">
            <label htmlFor="seo-meta-title" className="text-sm font-medium text-[#667085]">
              Meta Title
            </label>
            <Input
              id="seo-meta-title"
              value={metaTitle}
              onChange={(event) => onMetaTitleChange?.(event.target.value)}
              placeholder="Enter meta title"
              className="h-[46px]"
            />
            <p className="text-sm text-[#475467] leading-relaxed pt-1">
              Shown when your link is shared in DMs or social posts. Use your name + what you share.
            </p>
            <div className="bg-[#EEF4FF] rounded-lg p-3 flex items-start gap-2 mt-2">
              <span className="text-[#2970FF] font-bold text-[11px] mt-[3px] tracking-wide">EG.</span>
              <span className="text-[#344054] text-sm font-medium leading-[1.4]">
                Riya Desai · Real Marketing Opportunities for Your Next Move
              </span>
            </div>
            <p className="text-xs text-[#98A2B3] text-right font-medium pt-1">Sweet spot: 50-60 characters</p>
          </div>

          <div className="space-y-2">
            <label htmlFor="seo-meta-description" className="text-sm font-medium text-[#667085]">
              Meta Description
            </label>
            <Textarea
              id="seo-meta-description"
              value={metaDescription}
              onChange={(event) => onMetaDescriptionChange?.(event.target.value)}
              placeholder="Enter meta description"
              rows={4}
            />
            <p className="text-sm text-[#475467] leading-relaxed pt-1">
              Appears under your link preview. Two lines on what people will get and why to tap.
            </p>
            <div className="bg-[#EEF4FF] rounded-lg p-3 flex items-start gap-2 mt-2">
              <span className="text-[#2970FF] font-bold text-[11px] mt-[3px] tracking-wide">EG.</span>
              <span className="text-[#344054] text-sm font-medium leading-[1.4]">
                Curated marketing & growth opportunities that actually match where you're headed. New ones drop every day.
              </span>
            </div>
            <p className="text-xs text-[#98A2B3] text-right font-medium pt-1">Sweet spot: 120-160 characters</p>
          </div>
        </div>

        {onSave && (
          <div className="flex justify-end pt-4">
            <button
              onClick={onSave}
              disabled={isSaving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        )}
      </div>
    </SideOverlayDrawer>
  );
}
